<template>
  <v-col>
    <div class="d-flex">
      <field-group
        typeInput="v-textarea"
        :disabled="!isCreate"
        rows="2"
        prepend-inner-icon="mdi-link"
        :rules="apiRules"
        style="flex: 1"
        v-model="form.api"
        :error-messages="errors.api"
        filled
        label="Link api từ MTQG"
        no-label
      >
      </field-group>
      <v-tooltip bottom v-if="!isCreate && !loadingSynApi">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mx-2 mt-2"
            fab
            dark
            large
            color="cyan"
            depressed
            v-bind="attrs"
            v-on="on"
            @click="$emit('sync-api', form)"
          >
            <v-icon dark>
              mdi-sync
            </v-icon>
          </v-btn>
        </template>
        <span>Cập nhật dữ liệu từ API</span>
      </v-tooltip>
    </div>
    <div v-if="!isCreate">Thời gian dữ liệu: {{ form.time_data | dateTime }}</div>
    <div v-if="loadingSynApi">
      <div>Đang cập nhật dữ liệu từ API. Vui lòng đợi</div>
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
    </div>
  </v-col>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) },
    isCreate: Boolean,
    loadingSynApi: Boolean,
  },
  data: () => ({
    apiRules: [(v) => !!v || 'Link API không thể bỏ trống'],
  }),
  computed: {
    form() {
      return this.value
    },
  },
}
</script>
